// Extra facts saved on the onboarding answers doc (races/{legId}/onboarding/{uid}) and shown in the
// admin onboarding email: Momentum membership and 60° North Run history.

export const NORTH_RUN_FIRST_TIMER = "first_timer";
export const NORTH_RUN_RETURNING_VETERAN = "returning_veteran";

// "60° North Run 2026", "The 60 North Run", "60°North Run" ... all count.
export function isNorthRunRace(name) {
  if (typeof name !== "string") return false;
  return name.toLowerCase().replace(/[^a-z0-9]/g, "").includes("60northrun");
}

function getRaceYear(race) {
  const start = race?.raceInfo?.raceDateStart;
  if (!start) return null;
  const date = typeof start?.toDate === "function" ? start.toDate() : new Date(start);
  const year = date.getFullYear();
  return Number.isFinite(year) ? year : null;
}

// Earlier 60° North Run registrations: any 60° North Run race except the one being onboarded.
// Other distances of the same race (same raceId) or races in the same year don't count.
export function getPreviousNorthRunRaces(subscribedRaces, currentRace) {
  if (!subscribedRaces || typeof subscribedRaces !== "object") return [];
  const currentYear = getRaceYear(currentRace);
  return Object.entries(subscribedRaces)
    .filter(([legId, race]) => {
      if (!race || legId === currentRace?.legId) return false;
      if (currentRace?.raceId && race.raceId === currentRace.raceId) return false;
      if (!isNorthRunRace(race?.raceInfo?.name)) return false;
      const year = getRaceYear(race);
      if (currentYear && year) return year < currentYear;
      return true;
    })
    .map(([legId, race]) => ({ legId, name: race.raceInfo.name, year: getRaceYear(race) }));
}

// Only filled in when the race being onboarded is a 60° North Run; null for every other race.
export function getNorthRunHistory(subscribedRaces, currentRace) {
  if (!isNorthRunRace(currentRace?.raceInfo?.name)) return null;
  const previous = getPreviousNorthRunRaces(subscribedRaces, currentRace);
  return {
    status: previous.length > 0 ? NORTH_RUN_RETURNING_VETERAN : NORTH_RUN_FIRST_TIMER,
    previousRaces: previous.map((race) => race.name),
  };
}
